//auth
export const USER_LOADED_CLIENT = 'USER_LOADED_CLIENT';
export const AUTH_ERROR_CLIENT = 'AUTH_ERROR_CLIENT';
export const LOGIN_SUCCESS_CLIENT = 'LOGIN_SUCCESS_CLIENT';
export const LOGIN_FAIL_CLIENT = 'LOGIN_FAIL_CLIENT';
export const LOGOUT_CLIENT = 'LOGOUT_CLIENT';

//auth admin
export const ADMIN_LOADED = 'ADMIN_LOADED';
export const ADMIN_AUTH_ERROR = 'ADMIN_AUTH_ERROR';
export const ADMIN_LOGIN_SUCCESS = 'ADMIN_LOGIN_SUCCESS';
export const ADMIN_LOGIN_FAIL = 'ADMIN_LOGIN_FAIL';
export const ADMIN_LOGOUT = 'ADMIN_LOGOUT';

//users
export const GET_USER = 'GET_USER';
export const USERS_ERROR = 'USERS_ERROR';
export const GET_USERS = 'GET_USERS';
export const GET_PHONE = 'GET_PHONE';
export const CLEAR_USER = 'CLEAR_USER';
export const TOGGLE_FAVORITE = 'TOGGLE_FAVORITE';

//categories
export const GET_CATEGORIES = 'GET_CATEGORIES';
export const GET_CATEGORY = 'GET_CATEGORY';
export const GET_SUBCATEGORY = 'GET_SUBCATEGORY';
export const GET_SUBCATEGORIES = 'GET_SUBCATEGORIES';
export const ERROR_CATEGORIES = 'ERROR_CATEGORIES';

//profile
export const ADD_PROFILE_SERVICE = 'ADD_PROFILE_SERVICE';
export const PROFILE_ERRORS = 'PROFILE_ERRORS';
export const GET_PROFILE = 'GET_PROFILE'; 
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const UPDATE_PROFILE_SERVICE = 'UPDATE_PROFILE_SERVICE';
export const UPDATE_PROFILE_SERVICE_STATUS = 'UPDATE_PROFILE_SERVICE_STATUS';
export const DELETE_IMG_PROFILE = 'DELETE_IMG_PROFILE';
export const DELETE_PROFILE_SERVICE = 'DELETE_PROFILE_SERVICE';
export const GET_FAVORITES = 'GET_FAVORITES';
export const UPDATE_PROFILE_PAGE_STATUS = 'UPDATE_PROFILE_PAGE_STATUS';
export const UPDATE_PROFILE_SERVICE_STATUS_SUCCESS = 'UPDATE_PROFILE_SERVICE_STATUS_SUCCESS';

//address
export const GET_ADDRESS = 'GET_ADDRESS';
export const ADDRESS_ERROR = 'ADDRESS_ERROR';

//quote
export const GET_QUOTES = 'GET_QUOTES';
export const GET_ALL_QUOTES = 'GET_ALL_QUOTES';
export const GET_QUOTE = 'GET_QUOTE';
export const GET_REQUEST_QUOTE = 'GET_REQUEST_QUOTE';
export const GET_REQUESTS_QUOTES = 'GET_REQUESTS_QUOTES';
export const ERROR_QUOTE = 'ERROR_QUOTE';

//demand service
export const ERROR_DEMAND = 'ERROR_DEMAND';
export const GET_DEMANDS = 'GET_DEMANDS';
export const GET_DEMAND = 'GET_DEMAND';

//notifications
export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const MARK_NOTIFICATION_READ = 'MARK_NOTIFICATION_READ';
export const MARK_ALL_NOTIFICATIONS_READ = 'MARK_ALL_NOTIFICATIONS_READ';
export const UPDATE_INVITATION_STATUS = 'UPDATE_INVITATION_STATUS';
export const NOTIFICATION_ERROR = 'NOTIFICATION_ERROR';

//chat
export const GET_CHATS = 'GET_CHATS';
export const GET_MESSAGES = 'GET_MESSAGES';
export const ADD_MESSAGE = 'ADD_MESSAGE';
export const SET_CURRENT_CHAT = 'SET_CURRENT_CHAT';
export const CHAT_ERROR = 'CHAT_ERROR';
export const TOGGLE_CHAT = 'TOGGLE_CHAT';
export const MARK_CHAT_READ = 'MARK_CHAT_READ';
export const DELETE_CHAT = 'DELETE_CHAT';
export const CHAT_BLOQUEO = 'CHAT_BLOQUEO';
export const UPDATE_ONLINE_USERS = 'UPDATE_ONLINE_USERS';